class Stores {
    constructor() {
        
        this.storesList = document.querySelectorAll('.our-stores__item');
        this.map = null;
        this.geocode = null;

        if (!this.storesList) return;

        this.initMap();

        this.storesList.forEach((store) => {

            store.querySelector('a.show_map').addEventListener('click', (e) => {

                e.preventDefault();

                this.storesList.forEach((st) => { st.classList.remove('active'); });

                store.classList.add('active');

                let _id = e.target.dataset.id;
                let _address = document.querySelector('.address[data-address="' + _id + '"]').innerHTML;

                this.activateMap(_address);

            });

        });

    }

    activateMap(address) {

        this.geocoder.geocode({ address }, (results, status) => {
            if (status === "OK" && results[0]) {
                this.map.panTo(results[0].geometry.location);
                this.map.setZoom(15); // Adjust zoom level as you like
            } else {
                console.error("Geocode failed for " + address + ": " + status);
            }
        });

    }
    
    async initMap() {
        
        
        const { Map } = await google.maps.importLibrary("maps");
        // const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

        if (document.querySelectorAll('.our-stores__address .address').length > 0) {

            this.map = new Map(document.getElementById("map"), {
                center: { lat: 54.8, lng: -4.6 },
                zoom: 6,
                mapId: "DEMO_MAP_ID"
            });

            this.geocoder = new google.maps.Geocoder();

            let storeAddresses = [];

            document.querySelectorAll('.our-stores__address .address').forEach((address) => {
    
                storeAddresses.push(address.innerHTML);
    
            });
    
            for (const address of storeAddresses) {
                this.geocoder.geocode({ address }, (results, status) => {
                    if (status === "OK" && results[0]) {
                        new google.maps.Marker({
                            map: this.map,
                            position: results[0].geometry.location,
                            title: address,
                            icon: "//nordic-outdoor-shop.myshopify.com/cdn/shop/t/4/assets/map-pin.svg?v=141037794696867855621760533411",
                        });
                    } else {
                        console.error("Geocode failed for " + address + ": " + status);
                    }
                });
            }

        } else if (document.querySelector('.store-map__map')) {

            const geocoder = new google.maps.Geocoder();
            const address = document.querySelector('.store-map__address').innerHTML; // <--- Your starting address

            geocoder.geocode({ address }, (results, status) => {
                if (status === "OK" && results[0]) {
                    const map = new google.maps.Map(document.getElementById("map"), {
                        zoom: 17,
                        center: results[0].geometry.location
                    });

                    // Optional marker at the address
                    new google.maps.Marker({
                        map,
                        position: results[0].geometry.location,
                        title: address,
                        icon: "//nordic-outdoor-shop.myshopify.com/cdn/shop/t/4/assets/map-pin.svg?v=141037794696867855621760533411",
                    });
                } else {
                    console.error("Geocode failed: " + status);
                }
            });
        }

    }
}

let _stores = new Stores();